import React from "react";
import { connect } from "react-redux";
import { getHedgeNotes, addNoteToHedge, deleteNote } from "store/state/hedge";
import NotesDrawer from "components/Global/Notes/NotesDrawer";
import _ from "lodash";

class HedgeNotes extends React.Component {
  componentDidUpdate(prevProps, prevState) {
    const { hedgeId, isOpen } = this.props;
    const { isOpen: prevIsOpen } = prevProps;

    if (isOpen !== prevIsOpen && isOpen) {
      this.props.getHedgeNotes({
        modelName: "hedge",
        modelId: hedgeId,
        subKey: hedgeId
      });
    }
  }

  handleRemove = noteId => {
    const { hedgeId } = this.props;

    this.props.deleteNote({
      noteId: noteId,
      shouldUpdateAfter: true,
      modelName: "hedge",
      modelId: hedgeId,
      subKey: hedgeId
    });
  };

  render() {
    const { isOpen, closeNotes, hedgeNotes, hedgeId, addNoteToHedge } = this.props;
    const specificHedgeNotes = hedgeNotes[hedgeId] || [];

    return (
      <React.Fragment>
        <NotesDrawer
          drawerWidth={600}
          addNote={note => addNoteToHedge("hedge", hedgeId, note)}
          isOpen={isOpen}
          closeDrawer={closeNotes}
          notes={specificHedgeNotes}
          handleRemove={this.handleRemove}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ hedge }) => ({
  hedgeNotes: hedge.hedgeNotes
});

export default connect(
  mapStateToProps,
  {
    getHedgeNotes,
    addNoteToHedge,
    deleteNote
  }
)(HedgeNotes);
